module.exports = __webpack_public_path__ + "media/images/logo_horisontell-cc26fc5e70e5a80daeee5843c599012d.jpg";